import webservice from '../../../../services/webservice'
import { createAsyncThunk } from '@reduxjs/toolkit'

// Fetch paginated audit logs
export const fetchAuditlogs = createAsyncThunk('Auditlog/fetchAuditlogs', async (params) => {
    try {
        const queryParams = new URLSearchParams({
            page: params.page || 1,
            perPage: params.perPage || 10,
            q: params.q || '',
            sort: params.sort || 'desc',
            sortColumn: params.sortColumn || 'timestamp',
            screenName: params.screenName || ''
        });

        const response = await fetch(`${webservice}api/auditlog?${queryParams}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        
        return responseData;
    } catch (error) {
        console.error('Error fetching audit logs:', error);
        throw error;
    }
});

// Fetch distinct screen names with counts
export const fetchScreenNames = createAsyncThunk('Auditlog/fetchScreenNames', async () => {
    try {
        const response = await fetch(`${webservice}api/auditlog/screens`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error fetching screen names:', error);
        throw error;
    }
});
